import Controller from '@ember/controller';

export default class DocumentsRequestedController extends Controller {}
